import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import SearchFilters from '../../../../components/elements/SearchFilter';

import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import AdminBanner from '../../../../components/elements/AdminBanner';
import { postAsync, putAsync } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import { uuid4 } from '../../../../libs';

const SDManageList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [gridModalProjectCreate, setGridModalProjectCreate] = useState(false);
  const [gridModalMaApproveNotesCreate, setGridModalMaApproveNotesCreate] = useState(false);
  const [projectNotes, setProjectNotes] = useState('');
  const [maApproveNotes, setMaApproveNotes] = useState('');
  const [reason, setReason] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const navigate = useNavigate();
  const { t } = useTranslation();

  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const isLogin = () => {
    if (!token && !epUser) {
      navigate('/managementLogin');
    }
  };

  const SearchFilter = {
    epUserID: 0,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
  };
  const getData = async () => {
    setIsLoad(true);
    await postAsync(`ServiceDead/GetSDManagedFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`, SearchFilter)
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);

        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const bodyActive = {
    activeID: 1,
  };

  const handleActive = (e, id) => {
    onActive(e, id);
  };
  const handleInActive = (e, id) => {
    onInActive(e, id);
  };

  const onActive = async (e, Id) => {
    await putAsync('ServiceDead/SDActivation/', bodyActive, { id: Id })
      .then((res) => {
        toast.success(`${t('Updated Successfully')}`);
        getData();
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const bodyInActive = {
    // serviceDeadID: serviceDeadID,
    activeID: 2,
  };

  const onInActive = async (e, Id) => {
    await putAsync('ServiceDead/SDActivation/', bodyInActive, { id: Id })
      .then((res) => {
        toast.success(`${t('Deactivated Successfully')}`);
        getData();
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const openProjectNotesModal = (e, serviceDeadID) => {
    e.preventDefault();

    const selected = apiData.find((data) => data.serviceDeadID === serviceDeadID)?.reason;

    // setProjectNotes(selected);
    setReason(selected);
    setGridModalProjectCreate(true);
  };

  const closeProjectNotesModal = (e) => {
    e.preventDefault();
    setGridModalProjectCreate(false);
  };

  const openMaApproveNotesModal = (e, serviceDeadID) => {
    e.preventDefault();

    const selected = apiData.find((data) => data.serviceDeadID === serviceDeadID)?.maNotes;
    // const selectreason = apiData.find((data) => data.serviceDeadID === serviceDeadID)?.reason;
    // setReason(selectreason);
    setMaApproveNotes(selected);
    setGridModalMaApproveNotesCreate(true);
  };

  const closeMaApproveNotesModal = (e) => {
    e.preventDefault();
    setGridModalMaApproveNotesCreate(false);
  };

  const bodyGet = {
    epUserID: epUser,
  };

  const changePage = async ({ selected }) => {
    await postAsync('ServiceDead/GetSDFilterList/' + selected + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setTotalPages(response.page);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const SearchCampaignFilterList = async () => {
    try {
      const response = await postAsync(
        `ServiceDead/GetSDApprovalFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      setApiData(response?.data);
      setNext(pageOptions.pageNo);
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  // Export xlsl file
  const handleOnExport = () => {
    downloadCSV(apiData, 'Sd Manage List');
  };

  const handlePrint = (e) => {
    e.preventDefault();
    const tableContainer = document.createElement('div');
    tableContainer.className = 'tableData my-4';

    // Create and add the heading
    const heading = document.createElement('h1');
    heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
    heading.innerText = `${t('Service For Dead Report List')}`; // Replace with your desired heading text
    tableContainer.appendChild(heading);

    const table = document.createElement('table');
    table.innerHTML = `
    <thead style="background-color: #2f855a; color: white;">

      <tr>
        <th style="padding: 5px; border: 1px solid #ddd;">#</th>
        <th style="padding: 5px; border: 1px solid #ddd;">${t('Project Type')}</th>
        <th style="padding: 5px; border: 1px solid #ddd;">${t(`Relationship`)}</th>
        <th style="padding: 5px; border: 1px solid #ddd;">${t(`Dead Person Name`)}</th>
        <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Notes`)}</th>
        <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>
        <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>

      </tr>
    </thead>
    <tbody>
      ${apiData
        .map(
          (data, index) => `
            <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
              <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${data?.selectProjectTypeName}</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${
                data.relativeID === 1
                  ? 'Great Grand Father'
                  : data.maApproveID === 2
                    ? 'Great Grand Mother'
                    : data.maApproveID === 3
                      ? 'Grand Father'
                      : data.maApproveID === 4
                        ? 'Grand Mother'
                        : data.maApproveID === 5
                          ? 'Father'
                          : data.maApproveID === 6
                            ? 'Husband'
                            : data.maApproveID === 7
                              ? 'Mother'
                              : data.maApproveID === 8
                                ? 'Wife'
                                : data.maApproveID === 9
                                  ? 'Brother'
                                  : data.maApproveID === 10
                                    ? 'Sister'
                                    : data.maApproveID === 11
                                      ? 'Son'
                                      : data.maApproveID === 12
                                        ? 'Daughter'
                                        : data.maApproveID === 13
                                          ? 'Uncle'
                                          : data.maApproveID === 14
                                            ? 'Aunt'
                                            : 'Relative'
              }</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${data?.deadName}</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${
                data.maApproveID === 1 ? 'Approved' : data.maApproveID === 2 ? 'Disapproved' : 'Pending'
              }</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${
                data.maApproveID === 1 ? 'Approved' : data.maApproveID === 2 ? 'Disapproved' : 'Pending'
              }</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${data.date}</td>
            </tr>
          `,
        )
        .join('')}
    </tbody>
  `;

    tableContainer.appendChild(table);
    document.body.appendChild(tableContainer);

    // Add CSS to hide everything except the table when printing
    const style = document.createElement('style');
    style.textContent = `
    @media print {

      body * {
        visibility: hidden;
        height: 0;

      }
      .tableData, .tableData * {
        visibility: visible;
      }
      .tableData {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: auto;
        overflow: visible;
      }
    }
  `;
    document.head.appendChild(style);

    // Trigger the print dialog
    window.print();

    // Clean up by removing the table container and style from the DOM
    document.body.removeChild(tableContainer);
    document.head.removeChild(style);

    return 'success';
  };

  return (
    <div className="pb-96 lg:pb-54">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
   
          <div className="container-fluid">
            <div className="row justify-center">
              <SearchFilters
                handleSearch={SearchCampaignFilterList}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Service For Dead Manage List'}
              />

              <div className="col-xl-11 pb-44 md:pb-0 pt-9">
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                  {isLoad ? (
                    <LoadingAnimation />
                  ) : (
                    apiData.length > 0 && (
                      <Table className="text-sm tableData text-left rtl:text-right ">
                        <Table.Header className="text-xs text-white bg-customgreen uppercase bg-gray-50 ">
                          <Table.Row>
                            <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Project Name')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Relationship')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Dead Person Name')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Reason')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Approval Status')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Managed Approved Notes')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Date')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Active Status')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Actions')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {apiData.map((data, index) => {
                            const sno = (next - 1) * pageOptions.pageSize + index + 1;

                            return (
                              <Table.Row items={apiData} key={uuid4()}>
                                <Table.Cell>{sno}</Table.Cell>
                                <Table.Cell>{data?.newProjectName}</Table.Cell>
                                {/* <Table.Cell>
                                  {data.relativeID === 1
                                    ? 'Great Grand Father'
                                    : data.maApproveID === 2
                                      ? 'Great Grand Mother'
                                      : data.maApproveID === 3
                                        ? 'Grand Father'
                                        : data.maApproveID === 4
                                          ? 'Grand Mother'
                                          : data.maApproveID === 5
                                            ? 'Father'
                                            : data.maApproveID === 6
                                              ? 'Husband'
                                              : data.maApproveID === 7
                                                ? 'Mother'
                                                : data.maApproveID === 8
                                                  ? 'Wife'
                                                  : data.maApproveID === 9
                                                    ? 'Brother'
                                                    : data.maApproveID === 10
                                                      ? 'Sister'
                                                      : data.maApproveID === 11
                                                        ? 'Son'
                                                        : data.maApproveID === 12
                                                          ? 'Daughter'
                                                          : data.maApproveID === 13
                                                            ? 'Uncle'
                                                            : data.maApproveID === 14
                                                              ? 'Aunt'
                                                              : 'Relative'}
                                </Table.Cell> */}
                                <Table.Cell>{data?.relationName}</Table.Cell>
                                <Table.Cell>{data?.deadName}</Table.Cell>
                                <Table.Cell>
                                  {/* Modal Create */}
                                  <>
                                    <MDBBtn
                                      style={{ float: 'right' }}
                                      className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2.5 me-2 text-center"
                                      onClick={(e) => openProjectNotesModal(e, data?.serviceDeadID)}
                                    >
                                      <VisibilityOutlinedIcon />
                                    </MDBBtn>

                                    <MDBModal
                                      show={gridModalProjectCreate}
                                      onHide={() => setGridModalProjectCreate(false)}
                                    >
                                      <MDBModalDialog>
                                        <MDBModalContent>
                                          {/* Move the Form component outside the ModalHeader */}
                                          <Form>
                                            <MDBModalHeader>
                                              <MDBModalTitle>{t('Reason')}</MDBModalTitle>
                                              <MDBBtn
                                                type="button"
                                                className="btn-close"
                                                color="none"
                                                onClick={closeProjectNotesModal}
                                              ></MDBBtn>
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                              <div className="container-fluid bd-example-row">{reason}</div>
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                              <MDBBtn color="secondary" onClick={closeProjectNotesModal}>
                                                {t('close')}
                                              </MDBBtn>
                                            </MDBModalFooter>
                                          </Form>
                                        </MDBModalContent>
                                      </MDBModalDialog>
                                    </MDBModal>
                                  </>
                                  {/* end */}
                                </Table.Cell>
                                <Table.Cell>
                                  {data.maApproveID === 1
                                    ? 'Approved'
                                    : data.maApproveID === 2
                                      ? 'Disapproved'
                                      : 'Pending'}
                                </Table.Cell>
                                <Table.Cell>
                                  {/* Modal Create */}
                                  <>
                                    <MDBBtn
                                      style={{ float: 'right' }}
                                      className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2.5 me-2 text-center"
                                      onClick={(e) => openMaApproveNotesModal(e, data?.serviceDeadID)}
                                    >
                                      <VisibilityOutlinedIcon />
                                    </MDBBtn>

                                    <MDBModal
                                      show={gridModalMaApproveNotesCreate}
                                      onHide={() => setGridModalMaApproveNotesCreate(false)}
                                    >
                                      <MDBModalDialog>
                                        <MDBModalContent>
                                          {/* Move the Form component outside the ModalHeader */}
                                          <Form>
                                            <MDBModalHeader>
                                              <MDBModalTitle>{t('Managed Approved Notes')}</MDBModalTitle>
                                              <MDBBtn
                                                type="button"
                                                className="btn-close"
                                                color="none"
                                                onClick={(e) => closeMaApproveNotesModal(e)}
                                              ></MDBBtn>
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                              <div className="container-fluid bd-example-row">{maApproveNotes}</div>
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                              <MDBBtn color="secondary" onClick={(e) => closeMaApproveNotesModal(e)}>
                                                {t('close')}
                                              </MDBBtn>
                                            </MDBModalFooter>
                                          </Form>
                                        </MDBModalContent>
                                      </MDBModalDialog>
                                    </MDBModal>
                                  </>
                                  {/* end */}
                                </Table.Cell>
                                <Table.Cell>{data.date}</Table.Cell>
                                <Table.Cell>
                                  {data?.activeID == true ? (
                                    <label
                                      style={{
                                        backgroundColor: 'lightgreen',
                                        fontWeight: 'bold',
                                        color: 'green',
                                        padding: '5px',
                                        width: '70px',
                                        textAlign: 'center',
                                        borderRadius: '5px',
                                      }}
                                    >
                                      {t('Active')}
                                    </label>
                                  ) : (
                                    <label
                                      style={{
                                        backgroundColor: 'lightpink',
                                        fontWeight: 'bold',
                                        color: 'red',
                                        padding: '5px',
                                        width: '70px',
                                        textAlign: 'center',
                                        borderRadius: '5px',
                                      }}
                                    >
                                      {t('Inactive')}
                                    </label>
                                  )}
                                </Table.Cell>

                                <Table.Cell>
                                  <div>
                                    <input
                                      checked={data?.activeID == true}
                                      onChange={(e) => handleActive(e, data.serviceDeadID)}
                                      className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
                                      id={`react-switch-new-${data?.serviceDeadID}`}
                                      name={`react-switch-new-${data?.serviceDeadID}`}
                                      type="radio"
                                    />
                                    <label>{t('Active')}</label>
                                  </div>

                                  <div className="flex flex-row">
                                    <input
                                      checked={data?.activeID == 2}
                                      onChange={(e) => handleInActive(e, data.serviceDeadID)}
                                      className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
                                      id={`react-switch-new-${data?.serviceDeadID}`}
                                      name={`react-switch-new-${data?.serviceDeadID}`}
                                      type="radio"
                                    />
                                    <label>{t('Inactive')}</label>
                                  </div>
                                </Table.Cell>
                              </Table.Row>
                            );
                          })}
                        </Table.Body>
                      </Table>
                    )
                  )}
                  {datanotfound && <DataNotFound />}
                </div>

                <div className="flex flex-row px-12 justify-between">
                  <Menu pagination>
                    <Menu.Item>
                      <ReactPaginate
                        previousLabel={t('Previous')}
                        nextLabel={t('Next')}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={'paginationButtons'}
                        previousLinkClassName={'previousButton'}
                        nextLinkClassName={'nextButton'}
                        disabledClassName={'paginationDisabled'}
                        activeClassName={'paginationActive'}
                      />
                    </Menu.Item>
                  </Menu>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      ;
    </div>
  );
};

export default SDManageList;
